import { render, staticRenderFns } from "./TruncateTooltip.vue?vue&type=template&id=3c6e8d74"
import script from "./TruncateTooltip.vue?vue&type=script&lang=js"
export * from "./TruncateTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports